import React from "react";
import PropTypes from "prop-types";
import List, { ListItem, ListItemIcon, ListItemText } from 'material-ui/List';
import Avatar from 'material-ui/Avatar';

// Utilities
import kebabCase from "lodash/kebabCase";

// Components
import Helmet from "react-helmet";
import Link from "gatsby-link";
import { GetTagPicture, GetLink } from './chooser';

const TagsPage = ({
  data: { allMarkdownRemark: { group }, site: { siteMetadata: { title } } },
}) => (
  <div>
    <Helmet title={title} />
    <div>
      <h1>Tags</h1>
      <List component="nav" className="tag-list">
      {group.map(tag => (
        <Link key={tag.fieldValue+'link'} style={{ boxShadow: 'none', marginRight: '5px' }} to={GetLink(tag.fieldValue)}>        
        <ListItem button key={tag.fieldValue} href={GetLink(tag.fieldValue)}>
          <Avatar src={GetTagPicture(tag.fieldValue)}/>
          <ListItemText inset primary={tag.fieldValue} secondary={tag.totalCount} />
        </ListItem>
        </Link>        
        ))}
      </List>
      <ul>
      </ul>
    </div>
  </div>
);

TagsPage.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      group: PropTypes.arrayOf(
        PropTypes.shape({
          fieldValue: PropTypes.string.isRequired,
          totalCount: PropTypes.number.isRequired,
        }).isRequired
      ),
    }),
    site: PropTypes.shape({
      siteMetadata: PropTypes.shape({
        title: PropTypes.string.isRequired,
      }),
    }),
  }),
};

export default TagsPage;

export const pageQuery = graphql`
query TagsQuery {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(
      limit: 2000,
      filter: { frontmatter: { draft: { ne: true } } }
    ) {
      group(field: frontmatter___tags) {
        fieldValue
        totalCount
      }
    }
  }
`;


// WEBPACK FOOTER //
// ./src/tags/index.js